import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo5() {
    const section = 'patzcuaro';
    const title = 'Pátzcuaro';
    const description = 'Un viaje a Pátzcuaro del inframundo, ¡qué locura!';
    const text = '<p>Me sentía como en un sueño muy raro, todo confuso, y de repente, Tinskani, una calaca, se estaba peleando con Taquito, mi perro. Después de que se calmaron, Tinskani me tocó la frente y pude ver mejor, después  llegamos a <b>Pátzcuaro</b>, un pueblo igualito al de Michoacán pero en otro mundo.</p><p>El Pátzcuaro de mi mundo es un pueblo mágico que parece detenido en el tiempo, con sus calles empedradas, sus casas blancas de techos rojos y sus plazas llenas de árboles enormes. Lo que más me encanta es la Basílica, que guarda a la Virgen de la Salud, y el lago inmenso donde se refleja el cielo. Mi abuelita siempre me contaba que ahí fue un territorio super importante para el gran reino purépecha y que su nombre significa "la puerta del cielo", ¡y la verdad que sí se siente así! Pátzcuaro me enseña que en la tranquilidad y la belleza simple de un pueblo se guarda la historia más grande, y que cuidar nuestros lagos y tradiciones es como proteger un pedacito de paraíso.</p><p>¡Pero el Patzuaro del inframundo se ve muy distinto! Ahí, todas las casas están hechas de una piedra rosa y decoradas con muchas grecas. Cada una de esas grecas representa el fin del ciclo de vida de alguien de esa familia. Dentro de cada casa, pude ver el "corazón del hogar" que es una gran llama verde que siempre arderá mientras un mienmbro de la familia siga experimentando la vida.</p><p>Mientras recorríamos el pueblo, pude ver a todas las almas de los muertos, ¡eran como esqueletos! Para no llamar la atención, le dije a Taquito que los distrajera, ¡y se puso a bailar y a ladrar como si estuviera animando al público!</p><p>Aprovechamos para ir a una "estela", que es como un viento mágico que atraviesa todo el inframundo. Nos lanzamos al vacío para ir al Mictlán. ¡Fue una aventura súper genial! Tinskani me dijo que yo era un  ser espíritual experimentando una vida humana.</p><p>Mientras todo esto pasaba, mis primos me sintieron. ¡Don Juan se dio cuenta de que un ser oscuro me anda buscando!</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo5.png';
    const image_number = 'https://www.diadelavida.com/images/numbers/5.png'
    const image_size = 'cover';
    const image_position = 'center bottom';
    const image_height = 450;
    const comments_prompt = '¿Conoces Pátzcuaro del mundo de los vivos? ¿Te gustaría conocerlo? ¡Cuéntanos en los comentarios!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo5_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 5',
            description: '¡Los colores de este Patzcuaro son increíbles!'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_valentina_02.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 5',
            description: '¿Qué te parede mi outfit para pasar desapercibida?'
        },
        {
            id: 3,
            src: 'https://diadelavida.com/images/cards/card_taquito_02.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 5',
            description: 'Más tierno que nunca, ¡Taquito es el mejor!'
        }
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}